import { memo } from "react";

const ActionMenuMore = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99999 9.19999C8.66273 9.19999 9.19999 8.66273 9.19999 7.99999C9.19999 7.33725 8.66273 6.79999 7.99999 6.79999C7.33724 6.79999 6.79999 7.33725 6.79999 7.99999C6.79999 8.66273 7.33724 9.19999 7.99999 9.19999Z"
      fill="currentColor"
    />
    <path
      d="M7.99999 5.19999C8.66273 5.19999 9.19999 4.66273 9.19999 3.99999C9.19999 3.33725 8.66273 2.79999 7.99999 2.79999C7.33724 2.79999 6.79999 3.33725 6.79999 3.99999C6.79999 4.66273 7.33724 5.19999 7.99999 5.19999Z"
      fill="currentColor"
    />
    <path
      d="M7.99999 13.2C8.66273 13.2 9.19999 12.6627 9.19999 12C9.19999 11.3372 8.66273 10.8 7.99999 10.8C7.33724 10.8 6.79999 11.3372 6.79999 12C6.79999 12.6627 7.33724 13.2 7.99999 13.2Z"
      fill="currentColor"
    />
  </svg>
);

export default memo(ActionMenuMore);
